import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { InvitationResponse, RegisterWithInvitationRequest } from '../models/invitation.model';

@Injectable({
  providedIn: 'root'
})
export class InvitationApiService {
  private readonly apiUrl = `${environment.apiUrl}api/invitations`;

  constructor(private http: HttpClient) {}

  getByToken(token: string): Observable<InvitationResponse> {
    return this.http.get<InvitationResponse>(`${this.apiUrl}/token/${token}`);
  }

  registerWithInvitation(request: RegisterWithInvitationRequest): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/register`, request);
  }
}
